// ── Modelos de Streaming RFW — Bloque 27 ──
// Explicación clara de las dos opciones. Sin CentovaCast. Sin proveedores.

export interface StreamingModel {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  features: string[];
  ctaLabel: string;
  ctaUrl: string;
  highlighted: boolean;
}

export const streamingModels: StreamingModel[] = [
  {
    id: 'own-stream',
    title: 'Ya tengo Streaming',
    subtitle: 'Conectá tu señal en minutos y salí al aire sin cambiar nada de tu infraestructura actual.',
    icon: 'ri-plug-line',
    features: [
      'Conectás tu stream actual sin migrar nada',
      'Compatible con cualquier servidor de streaming',
      'Prueba de conexión automática antes de publicar',
      'Tu radio aparece en RFW al instante',
    ],
    ctaLabel: 'Conectar mi stream',
    ctaUrl: '/register-radio',
    highlighted: false,
  },
  {
    id: 'rfw-hosting',
    title: 'Necesito Hosting RFW',
    subtitle: 'Nosotros nos encargamos de todo el streaming. Vos solo creás contenido y transmitís.',
    icon: 'ri-cloud-line',
    features: [
      'Servidores RFW de alta calidad y baja latencia',
      'AutoDJ incluido para mantener tu señal 24/7',
      'Estadísticas de oyentes en tiempo real',
      'Soporte técnico RFW sin costo adicional',
    ],
    ctaLabel: 'Contratar Hosting RFW',
    ctaUrl: '/pricing',
    highlighted: true,
  },
];